/** WoW class colors for roster / council UI (matches PlannerPage palette). */
const WOW_CLASS_COLORS: Record<string, string> = {
  Warrior: "#C79C6E",
  Paladin: "#F58CBA",
  Hunter: "#ABD473",
  Rogue: "#FFF569",
  Priest: "#FFFFFF",
  DeathKnight: "#C41F3B",
  Shaman: "#0070DE",
  Mage: "#40C7EB",
  Warlock: "#8787ED",
  Monk: "#00FF96",
  Druid: "#FF7D0A",
  DemonHunter: "#A330C9",
  Evoker: "#33937F",
};

export function getWowClassColor(className: string | null | undefined): string {
  if (!className) return "#A3A3A3";
  const key = className.replace(/\s+/g, "");
  if (WOW_CLASS_COLORS[key]) return WOW_CLASS_COLORS[key];
  const found = Object.keys(WOW_CLASS_COLORS).find((k) => k.toLowerCase() === key.toLowerCase());
  return found ? WOW_CLASS_COLORS[found] : "#A3A3A3";
}
